<template>
  <div class="maxw">
    <h2>Detalles Factura</h2>
    <b-form v-on:submit.prevent="updateFactura">
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Num. Factura">
            <h2>{{ factura.serieIdentifier }} / {{ factura.numFact }}</h2>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Cliente">
            {{ factura.cliente.nombre }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Fecha Factura">
            {{ factura.fechaFactura | date }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Fecha Vencimiento"
            label-for="dp-vencimiento"
          >
            {{ factura.fechaVencimiento | date }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Cobrada">
            <b-form-checkbox
              v-model="factura.isPagada"
              name="check-button"
              switch
              disabled
            >
              Pendiente /Cobrada
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Base Fra.">
            {{ factura.precioBase }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Iva %">
            {{ factura.iva }}%
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Iva €">
            {{ factura.impuestoIVA }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Total Fra.">
            {{ factura.totalFactura }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Banc">
            <p v-if="factura.banc !== null">
              {{ factura.banc.nombre }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h3>Lineas Factura</h3>
        </b-col>
      </b-row>
      <b-table
        striped
        hover
        small
        :items="factura.facturaDetalles"
        :fields="DetalleFields"
      >
        <template v-slot:cell(show_details)="row">
          <b-form-checkbox
            v-if="row.item.productoDescripcion != null"
            v-model="row.detailsShowing"
            @change="row.toggleDetails"
          />
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col>{{ row.item.productoDescripcion }}</b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button
            class="mr-2"
            variant="outline-success"
            @click="
              $router.push({
                name: 'FacturaEdit',
                params: { factura: factura },
              })
            "
            >Editar</b-button
          >
          <b-button
            class="mr-2"
            variant="outline-danger"
            @click="
              $router.push({
                name: 'FacturaDelete',
                params: { factura: factura },
              })
            "
            >Esborrar</b-button
          >
          <b-button class="mr-2" variant="outline-primary"
            ><router-link :to="{ name: 'Factures' }"
              >Cancel</router-link
            ></b-button
          >
        </b-col>
      </b-row>
      <b-form-input
        :hidden="true"
        type="text"
        v-model="factura.identifier"
      ></b-form-input>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    factura: Object
  },
  data () {
    return {
      DetalleFields: [
        {
          key: 'producte',
          label: 'Descripción',
          sortable: false
        },
        {
          key: 'show_details',
          label: 'Detalls'
        },
        {
          key: 'cantidad',
          label: 'Q',
          sortable: false
        },
        {
          key: 'productoPrecio',
          label: 'Precio',
          sortable: false
        },
        {
          key: 'productoDescuento',
          label: 'Dto',
          sortable: false
        },
        {
          key: 'precioLinea',
          label: 'Importe',
          sortable: false
        }
      ]
    }
  }
}
</script>
